module.exports = __webpack_public_path__ + "img/help.a57da69b.png";